import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { api, authState } from '../state/auth.js';
import { whenModule } from './plan.js';

// Vakantiedelegatie: members from /api/users/members carry `away` ({ until, delegate_name })
// while they're away. Used in owner pickers and on profile / org chart.

const fmt = d => (d ? new Date(`${d}T12:00:00`).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }) : '');

export const awayText = away => (away ? `afwezig${away.until ? ` t/m ${fmt(away.until)}` : ''}` : '');

// "Piet Jansen (afwezig t/m 12 okt)"
export const memberLabel = u => `${u.display_name || u.email}${u.away ? ` (${awayText(u.away)})` : ''}`;

// Under a picker: the chosen member is away, and who helps out meanwhile
export function AwayNote({ users, userId }) {
  const u = users.find(x => String(x.id) === String(userId));
  if (!u?.away) return null;
  return (
    <div class="text-sm" style="margin-top:4px;color:var(--color-warning,#b45309)">
      🌴 {(u.display_name || '').split(' ')[0]} is {awayText(u.away)}. Vervanger {u.away.delegate_name} werkt mee en krijgt de meldingen.
    </div>
  );
}

// A small label for a profile header or org chart
export function AwayBadge({ away }) {
  if (!away) return null;
  return (
    <span title={`Vervanger: ${away.delegate_name}`}
      style="display:inline-flex;align-items:center;gap:4px;font-size:12px;font-weight:600;padding:2px 8px;border-radius:999px;background:var(--color-warning-bg,#fef3c7);color:var(--color-warning,#92400e);white-space:nowrap">
      🌴 {awayText(away)} · {away.delegate_name}
    </span>
  );
}

// Who is away now in this club: { [userId]: { until, delegate_id, delegate_name } }
export function useAway(clubKey) {
  const [away, setAway] = useState({});
  useEffect(() => {
    const { userId, activeClubId } = authState.value;
    whenModule(`${userId}:${activeClubId}`, 'delegation').then(on => (on ? api('/api/delegatie/away') : {})).then(a => setAway(a || {})).catch(() => setAway({}));
  }, [clubKey]);
  return away;
}
